import {TableDefinition} from '../../models';

export const PRESENTATION_TABLE_DEFINITION: TableDefinition = [
  {
    key: 'API.fields.Presentation.id',
    prop: 'id',
    visible: false,
    objectName: 'Presentation',
    searchFieldType: 'NUMBER',
  },
  {
    key: 'API.fields.Presentation.name',
    prop: 'name',
    visible: true,
    objectName: 'Presentation',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.Presentation.description',
    prop: 'description',
    visible: false,
    objectName: 'Presentation',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.Presentation.status',
    prop: 'status',
    visible: true,
    objectName: 'Presentation',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.Presentation.createdAt',
    prop: 'createdAt',
    visible: true,
    objectName: 'Presentation',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.Presentation.thumbnailUrl',
    prop: 'thumbnailUrl',
    visible: false,
    image: true,
    objectName: 'Presentation',
  },
];
